export default __webpack_public_path__ + "static/media/Rectangle 3362.8c2e94dc.png";